<template>
<div>
  <basic-container :loading="loading">
    <el-table :data="tableData" height="600" border>
      <el-table-column label="合同编号" prop="contractNo" align="center" width="100"/>
      <el-table-column label="合同类型" prop="contractTypeName" align="center" width="100"/>
      <el-table-column label="合同名称" prop="contractName" align="center" /> 
      <el-table-column label="有效期" align="center" width="220">
        <template slot-scope="scope">
          {{scope.row.startTime | dateTimeFormatter}} - {{scope.row.endTime | dateTimeFormatter}}
        </template>
      </el-table-column>

      <el-table-column label="签署状态" prop="endTime" align="center"> 
        <template slot-scope="scope">
          <span :class="{status: scope.row.contractSignStatus === 1}">
            {{scope.row.contractStatusName}}
            {{scope.row.contractSignStatus | singatory}}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="150">
        <template slot-scope="scope">
          <template v-if="scope.row.contractSignStatus === 1">
            <el-button type="text" @click="handleSignContract(scope.row)">签署</el-button>
            <el-button type="text" @click="refuseSignContract(scope.row)">拒签</el-button>
          </template>
          <el-button type="text" @click="toDetail(scope.row)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="footer">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="pageNum"
        :page-size.sync="pageSize"
        :page-sizes="[10]"
        layout="total, sizes, prev, pager, next, jumper"
        :total.sync="totalCount"
        background
      />
    </div>
  </basic-container>
  <auth-dialog ref="authDialog" @success="handleAuthSuccess"></auth-dialog>
  <el-dialog title="短信验证" :visible.sync="authCodeDialog" :show-close="false" width="350px" class="dialog" center>
    <div class="content">
      <div class="">请输入手机号尾号{{(phone+'').slice(-4)}}收到的短信验证码</div>
      <div class="code-wrap">
        <div class="code-input-wrap">
          <input v-model="input0" ref="input0" class="code-input" type="number" maxlength="1" @keydown.8="deleteValue($event,'input0','input0')" @input="changeValue($event,'input0','input1')" @click.prevent>
          <input v-model="input1" ref="input1" class="code-input" type="number" maxlength="1" @keydown.8="deleteValue($event,'input1','input0')" @input="changeValue($event,'input1','input2')" @click.prevent>
          <input v-model="input2" ref="input2" class="code-input" type="number" maxlength="1" @keydown.8="deleteValue($event,'input2','input1')" @input="changeValue($event,'input2','input3')" @click.prevent>
          <input v-model="input3" ref="input3" class="code-input" type="number" maxlength="1" @keydown.8="deleteValue($event,'input3','input2')" @input="changeValue($event,'input3','input4')" @click.prevent>
          <input v-model="input4" ref="input4" class="code-input" type="number" maxlength="1" @keydown.8="deleteValue($event,'input4','input3')" @input="changeValue($event,'input4','input5')" @click.prevent>
          <input v-model="input5" ref="input5" class="code-input" type="number" maxlength="1" @keydown.8="deleteValue($event,'input5','input4')" @input="changeValue($event,'input5')" @click.prevent>
        </div>
        <div class="code-input-mask" @click="handleClick"></div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer" style="text-align: center">
      <el-button @click="authCodeDialog = false">取 消</el-button>
      <el-button type="primary" @click="checkCodeByPhone">保 存</el-button>
    </div>
  </el-dialog>
  <el-dialog class="contract-dialog" title="请选择使用的垫资签章" :visible.sync="contractSignatureDialog" width="530px" :show-close="false" center>
    <div class="contract">
      <div class="item" v-for="item in signatureList" :key="item.signatureImgId" @click="handleSelectSignature(item)">
        <div class="contract-img">
          <img :src="item.image" alt="">
          <div class="active el-icon-success" v-if="selectSignatureImgId === item.signatureImgId"></div>
        </div>
        <div class="contract-name">{{item.companyName}}</div>
        <div class="contract-type">({{item.signatureImgType | signatureImgType}})</div>
        <div class="contract-status" v-if="selectedContractInfo.partyA !== item.companyName">所属企业不可用</div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button :disabled="!selectSignatureImgId" type="primary" @click="confirmSignContract">使用公章签署合同</el-button>
    </span>
  </el-dialog>
  <el-dialog title="确认要拒签合同吗?" :visible.sync="signConfirmDialog" :show-close="false" width="400px" class="dialog" center>
    <div class="content">
      如果对合同内容存在疑问，可以先和业务经理联系以后再做决定
    </div>
    <div slot="footer" class="dialog-footer" style="text-align: center">
      <el-button @click="signConfirmDialog = false">取 消</el-button>
      <el-button type="primary" @click="confirmRefuseSign">确 认</el-button>
    </div>
  </el-dialog>
</div>
</template>
<script>
import AuthDialog from '../components/AuthDialog.vue'
import {dateTimeFormatter} from '@/utils/utils.js'
export default {
  components: { AuthDialog },
  data() {
    return {
      authCodeDialog: false,
      contractSignatureDialog: false,
      signConfirmDialog: false,
      pageNum: 1,
      pageSize: 10,
      totalCount: 0,
      loading: false,
      tableData: [],
      signatureList: [],
      input0: '',
      input1: '',
      input2: '',
      input3: '',
      input4: '',
      input5: '',
      phone: '',
      selectSignatureImgId: '',
      selectedContractInfo: {}
    }
  },
 computed: {
   codeInput() {
     return this.input0 + this.input1 + this.input2 + this.input3 + this.input4 + this.input5
   }
 },
  activated() {
    this.getContractsInfo()
    this.getSignatureImgListByGroupId()
  },
  methods: {
    handleClick (e) {
      const index = this.codeInput.length === 6 ? 5 : this.codeInput.length
      this.$refs['input'+index].focus()
    },
    deleteValue (e,inputValue, previousItem) { // 键盘按下时$event，当前input，上一个input
      if (!e.target.value) {
        this.$refs[previousItem].focus() 
        this[previousItem] = ''
        return
      }
      e.target.value = this[inputValue] = ''
    },
    changeValue (e, inputValue, nextItem) { // 键盘抬起时$event，当前input，下一个input
      if (e.inputType === 'deleteContentBackward') return
      this[inputValue] = e.target.value = e.target.value.slice(0, 1)
      if (!e.target.value) return
      if (nextItem) {
        this.$refs[nextItem].focus()
        this[nextItem] = ''
      }
    },
    async handleSignContract(row) { // 签署按钮
      this.selectedContractInfo = row
      try {
        let result = await this.judgeCompanyRegistered()
        if (result) {
          this.sendPhoneCode()
          return
        }
        this.$refs.authDialog.show()
      } catch (error) {}
    },
    handleAuthSuccess () {
      this.sendPhoneCode()
    },
    refuseSignContract(row) {
      this.selectedContractInfo = row
      this.signConfirmDialog = true
    },
    async confirmRefuseSign() {
      const res = await _api.contract.refuseContract({signType: 1, contractNo: this.selectedContractInfo.contractNo, reason: '请联系销售再次确认、协调合同内容'})
      if (!res || !res.ret || !res.data) {
        return
      }
      this.$message({
        message: '合同拒签成功',
        type: 'success'
      })
      this.signConfirmDialog = false
      this.getContractsInfo()
    },
    handleSizeChange(val) {
      this.pageNum = 1
      this.getContractsInfo()
    },
    handleCurrentChange(val) {
      this.getContractsInfo()
    },
    handleSelectSignature(data) { // 选择签章
      if(this.selectedContractInfo.partyA !== data.companyName) return
      this.selectSignatureImgId = data.signatureImgId
    },
    async confirmSignContract() { // 确认签署合同
      const params = {
        signType: 1,
        contractNo: this.selectedContractInfo.contractNo,
        signatureImgId: this.selectSignatureImgId, 
      }
      const res = await _api.contract.signContract(params)
      if (!res || !res.ret || !res.data) {
        return
      }
      this.contractSignatureDialog = false
      this.getContractsInfo()
    },
    async getContractsInfo() { // 获取合同信息
      this.loading = true
      const res = await _api.contract.getContractsInfo({contractType: null, contractStatus: null, signType: 1, pageNumber: this.pageNum, pageSize: this.pageSize})
      this.loading = false
      if (!res || !res.ret || !res.data) {
        this.tableData = []
        this.totalCount = 0
        return
      }
      const { items, totalCount } = res.data
      this.tableData = items || []
      this.totalCount = totalCount
    },
    async getSignatureImgListByGroupId() { // 获取签章列表
      const res = await _api.contract.getSignatureImgListByGroupId()
      if (!res || !res.ret || !res.data) {
        this.signatureList = []
        return
      }
      this.signatureList = res.data ||  []
    },
    async judgeCompanyRegistered() { // 查询企业认证
      const res = await _api.contract.judgeCompanyRegistered()
      if (!res || !res.ret || !res.data) {
        if (res.error.code === 4003) {
          return false
        }
        return Promise.reject()
      }
      return res.data.success
    },
    async sendPhoneCode() { // 发送手机验证码
      const res = await _api.contract.sendPhoneCode()
      if (!res || !res.ret || !res.data) {
        if (res.error.code === 5001) {
          this.authCodeDialog = true
        }
        return
      }
      this.authCodeDialog = true
      this.phone = res.data.phone
    },
    async checkCodeByPhone() {
      const res = await _api.contract.checkCodeByPhone({phone: this.phone, code: this.codeInput})
      if (!res || !res.ret || !res.data) {
        return
      }
      if (res.data.success) {
        this.authCodeDialog = false
        this.contractSignatureDialog = true
      }
    },
    toDetail(row) {
      this.$router.push({
        path: "/contract/detail",
        query: {
          contractNo: row.contractNo
        }
      })
    }
  },
  filters: {
    dateTimeFormatter(val) {
      if (!val) return ''
      return dateTimeFormatter(val*1000, 'YYYY-MM-DD')
    },
    signatureImgType(value) {
      switch (value) {
        case 1:
          return '公章'
        case 2:
          return '合同专用章'
        default:
          return ''
      }
    },
    singatory(val) {
      switch (val) {
        case 1:
          return `（甲方签署）`
        case 2:
          return `（乙方签署）`
        case 3:
          return `（丙方签署）`
        default:
          return ''
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.title {
  font-size: 16px;
  color: #409eff;
}

.no-appoint {
  color: #FF4500;
  text-align: center;
  height: 500px;
  margin-top: 60px;
}
.code-wrap {
  margin-top: 20px;
  position: relative;
  .code-input-mask {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
}
.code-input-wrap  {
  display: flex;
  input {
    margin: 0 5px;
    width: 40px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    border: 1px solid rgb(231,231,231);
    caret-color: rgb(78,114,249)
  }
  /* 去掉input[type=number]浏览器默认的icon显示 */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button { // chrome
      -webkit-appearance: none;
      appearance: none;
      margin: 0;
  }
  input{ // 火狐
      -moz-appearance:textfield;
  }
}
.contract {
  padding-bottom: 10px;
  display: flex;
  overflow-y: scroll;
  .item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex: none;
    width: 160px;
    .contract-img {
      position: relative;
      width: 120px;
      height: 120px;
      img {
        width: 100%;
        height: 100%;
      }
      .active {
        position: absolute;
        top: 0;
        right: 0;
        font-size: 24px;
        color: rgb(64,102,248);
      }
    }
    .contract-name {
      margin: 10px 0 5px;
      font-size: 14px;
      font-weight: 600;
    }
    .contract-type {
      font-size: 12px;
    }
    .contract-status {
      margin-top: 2px;
      font-size: 12px;
      color: red;
    }
  }
}

</style>
<style scoped>
.dialog >>> .el-dialog__body {
  padding: 0 20px 20px;
}
.contract-dialog >>> .el-dialog__body {
  padding: 10px 20px 0;
}
</style>
